/**
 * @generated SignedSource<<10787c70a609a7a0e3f672fa0bdbeac8>>
 * @relayHash 99a722ce70940e2d7cd60c4d4307d6eb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/538.0.0-2025-12-02T22:09:23.064Z/homepageRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homepageRootQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  fetchInitialHomepage: boolean;
  hasUserId: boolean;
  homepageId: string;
  isClient: boolean;
  isMobile: boolean;
  isTrade: boolean;
  isTrendingCreatorsVariant: boolean;
  isVideoComponentTestVariant: boolean;
  priceBookName: string;
  userCountryCode: string;
  userId: string;
  userType: string;
};
export type homepageRootQuery$data = {
  readonly viewer: {
    readonly homepage: {
      readonly modules: ReadonlyArray<{
        readonly __id: string;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"getHomePageMetaContent_homepage">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedLayout_viewer">;
  };
};
export type homepageRootQuery = {
  response: homepageRootQuery$data;
  variables: homepageRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchInitialHomepage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobile"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrendingCreatorsVariant"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVideoComponentTestVariant"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v13 = [
  {
    "kind": "Variable",
    "name": "abTestList",
    "variableName": "abTestList"
  },
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "HomepageMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsDisplayTitle",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v25 = [
  (v24/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLinkable",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageWidth",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageHeight",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cta",
  "storageKey": null
},
v30 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "pdpMetaItems",
  "kind": "LinkedField",
  "name": "pdpMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topQuery",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Creator",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v32/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attribution",
      "storageKey": null
    },
    (v40/*: any*/),
    (v32/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v32/*: any*/)
          ],
          "storageKey": null
        },
        (v32/*: any*/)
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStorefrontOnly",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v31/*: any*/),
                (v39/*: any*/),
                (v23/*: any*/),
                (v32/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v50 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade"
    },
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v49/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": "mobileTitle",
      "args": (v51/*: any*/),
      "kind": "ScalarField",
      "name": "title",
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": "mobileText",
          "args": (v51/*: any*/),
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v39/*: any*/),
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v53/*: any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v53/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCountry",
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v57 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v58 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v59 = [
  (v57/*: any*/),
  (v49/*: any*/),
  {
    "kind": "Literal",
    "name": "uriRef",
    "value": "/collections/editors-picks/"
  },
  (v58/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFurniture",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v63 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v31/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v14/*: any*/),
      (v35/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      {
        "condition": "hasUserId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "heartPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "HEART"
              },
              (v30/*: any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioId",
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "folderPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "FOLDER"
              },
              (v30/*: any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v32/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v26/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v50/*: any*/),
      (v52/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v32/*: any*/),
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  (v62/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = [
  (v57/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  }
],
v67 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v63/*: any*/),
    "storageKey": null
  },
  (v64/*: any*/),
  (v65/*: any*/)
],
v68 = [
  (v57/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "EXCELLENT_VALUES_MODULE"
  }
],
v69 = [
  (v57/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "BEST_SELLING_MODULE"
  }
],
v70 = [
  (v57/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "ON_SALE_MODULE"
  }
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstItemPhotoWebPath",
  "storageKey": "firstItemPhotoWebPath(size:\"master\")"
},
v73 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  (v49/*: any*/),
  {
    "kind": "Literal",
    "name": "uriRef",
    "value": "/dealers/greenapple/shop/?sort=recommended"
  },
  (v58/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homepageRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedLayout_viewer"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getHomePageMetaContent_homepage",
                "selections": [
                  (v16/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v12/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "homepageRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v20/*: any*/),
                    "type": "TopHeroBannerModule",
                    "abstractKey": null
                  },
                  {
                    "condition": "fetchInitialHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewMoreLink",
                            "storageKey": null
                          }
                        ],
                        "type": "HeroModule",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v14/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v14/*: any*/),
                              (v23/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CollectionsModule",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v20/*: any*/),
                        "type": "EditorialModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "index",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "userType",
                            "variableName": "userType"
                          }
                        ],
                        "concreteType": "PromoModuleMessages",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              (v22/*: any*/),
                              {
                                "condition": "isMobile",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v23/*: any*/),
                                  (v28/*: any*/)
                                ]
                              },
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageCopy",
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isFullBleedImage",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "format",
                                "storageKey": null
                              },
                              {
                                "condition": "isMobile",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileImageUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileImageHeight",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mobileImageWidth",
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HeroBannerSettingsType",
                                "kind": "LinkedField",
                                "name": "heroBannerSettings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textAlignment",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentColor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eyeBrowText",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "headerText",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dekText",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ctaStyle",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentPosition",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "backgroundColor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bannerImageWidth",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaCopy",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "type": "PromoModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v19/*: any*/),
                      {
                        "condition": "isTrendingCreatorsVariant",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          (v14/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v26/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v29/*: any*/),
                              (v23/*: any*/),
                              (v28/*: any*/),
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "ShopByModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v20/*: any*/),
                    "type": "LocationsModule",
                    "abstractKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "condition": "hasUserId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      },
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 3
                      },
                      (v30/*: any*/)
                    ],
                    "concreteType": "PersonalizationModuleConnection",
                    "kind": "LinkedField",
                    "name": "personalization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizationModuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonalizationModule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "categoryItems",
                                "plural": true,
                                "selections": [
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v14/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v26/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v50/*: any*/),
                                  (v52/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "linkData",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "categoryTitle",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v32/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "editorsPicks",
                "args": (v59/*: any*/),
                "concreteType": "ItemSearchItemsConnection",
                "kind": "LinkedField",
                "name": "itemSearchItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v63/*: any*/),
                    "storageKey": null
                  },
                  (v64/*: any*/),
                  (v65/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "editorsPicks",
                "args": (v59/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedHeroCarousel_editorsPicks",
                "kind": "LinkedHandle",
                "name": "itemSearchItems"
              },
              {
                "condition": "hasUserId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "userPortfolios",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      },
                      {
                        "kind": "Literal",
                        "name": "portfolioTypes",
                        "value": [
                          "HEART"
                        ]
                      },
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "userIds.0",
                            "variableName": "userId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "userIds"
                      }
                    ],
                    "concreteType": "PortfoliosConnection",
                    "kind": "LinkedField",
                    "name": "portfolios",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfoliosEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v32/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": "mostSavedItems",
                "args": (v66/*: any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v67/*: any*/),
                "storageKey": "itemSearchTrending(first:6,module:\"MOST_SAVED_MODULE\")"
              },
              {
                "alias": "mostSavedItems",
                "args": (v66/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedMostSavedItemsCarousel_mostSavedItems",
                "kind": "LinkedHandle",
                "name": "itemSearchTrending"
              },
              {
                "alias": "excellentValuesItems",
                "args": (v68/*: any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v67/*: any*/),
                "storageKey": "itemSearchTrending(first:6,module:\"EXCELLENT_VALUES_MODULE\")"
              },
              {
                "alias": "excellentValuesItems",
                "args": (v68/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedExcellentValuesCarousel_excellentValuesItems",
                "kind": "LinkedHandle",
                "name": "itemSearchTrending"
              },
              {
                "alias": "bestsellingDesigns",
                "args": (v69/*: any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v67/*: any*/),
                "storageKey": "itemSearchTrending(first:6,module:\"BEST_SELLING_MODULE\")"
              },
              {
                "alias": "bestsellingDesigns",
                "args": (v69/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedBestsellingDesignsCarousel_bestsellingDesigns",
                "kind": "LinkedHandle",
                "name": "itemSearchTrending"
              },
              {
                "alias": "onSaleItems",
                "args": (v70/*: any*/),
                "concreteType": "ItemSearchTreandingConnection",
                "kind": "LinkedField",
                "name": "itemSearchTrending",
                "plural": false,
                "selections": (v67/*: any*/),
                "storageKey": "itemSearchTrending(first:6,module:\"ON_SALE_MODULE\")"
              },
              {
                "alias": "onSaleItems",
                "args": (v70/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedFeaturedModuleCarousel_onSaleItems",
                "kind": "LinkedHandle",
                "name": "itemSearchTrending"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OnSaleVertical",
                "kind": "LinkedField",
                "name": "onSaleVerticals",
                "plural": true,
                "selections": [
                  (v71/*: any*/),
                  (v39/*: any*/),
                  (v26/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isVideoComponentTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v73/*: any*/),
                "concreteType": "ItemSearchItemsConnection",
                "kind": "LinkedField",
                "name": "itemSearchItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v14/*: any*/),
                          (v35/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v26/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v50/*: any*/),
                          (v52/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          (v56/*: any*/),
                          (v32/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v64/*: any*/),
                  (v65/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v73/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedVideoComponentCarousel_itemSearchItems",
                "kind": "LinkedHandle",
                "name": "itemSearchItems"
              }
            ]
          },
          {
            "condition": "isTrendingCreatorsVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrendingCreator",
                "kind": "LinkedField",
                "name": "trendingCreators",
                "plural": true,
                "selections": [
                  (v71/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "trendingVerticalLinkData",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v30/*: any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasLoggedInWithApp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "deviceType",
                        "value": "IOS_APP"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasLoggedInWithDeviceType",
                    "storageKey": "hasLoggedInWithDeviceType(deviceType:\"IOS_APP\")"
                  },
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowSellerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  (v32/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/538.0.0-2025-12-02T22:09:23.064Z/homepageRootQuery",
    "metadata": {},
    "name": "homepageRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "36bf635b34238b634bb0b6a22c67ea06";

export default node;
